<template>
  <div class="container">
    <div class="row">
      <div class="col-1">
        <button class="btn teleperformance-purpura2" @click="Volver()">Volver</button>
      </div>
      <div class="col-11 text-center">
        <h4>Detalle de solicitud de cambio de horario</h4>
      </div>
      <div class="col-12">
        <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
          <tbody>
            <tr>
              <td class="w-50"><b>Agente Solicitante</b></td>
              <td class="w-50">{{ solicitud.nomagente_sistema }}</td>
            </tr>
            <tr>
              <td class="w-50"><b>Fecha Solicitado</b></td>
              <td class="w-50">{{ solicitud.fecha_creacion }}</td>
            </tr>
            <tr>
              <td class="w-50"><b>Estatus</b></td>
              <td class="w-50">{{ solicitud.nomestatus }}</td>
            </tr>
          </tbody>
        </table>

        <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
          <tbody>
            <template v-for="dia of dias">
              <tr>
                <td class="w-50">
                  <b>{{ dia.title }}</b>
                </td>
                <td class="w-50">{{ dia.hora_entrada }} - {{ dia.hora_salida }}</td>
              </tr>
              <tr>
                <td class="w-50 label-lunch">Lunch</td>
                <td class="w-50" v-if="dia.tiempo_lunch > 0">Si - {{ dia.tiempo_lunch }} minutos</td>
                <td class="w-50" v-else>No</td>
              </tr>
            </template>
          </tbody>
        </table>

        <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
          <tbody>
            <tr>
              <td class="w-50"><b>Motivo de rechazo</b></td>
              <td class="w-50">
                <select class="form-control" v-model="solicitud.idmotivorechazo">
                  <option :value="null">Seleccione un motivo</option>
                  <option v-for="mr of motivos_de_rechazo" :value="mr.idmotivorechazo">{{ mr.nombre }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="w-50">
                <button class="btn btn-danger" @click="Rechazar()">Rechazar</button>
              </td>
              <td class="w-50">
                <button class="btn btn-success" @click="Aprobar()">Aprobar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment-timezone";
import * as _ from "lodash";
import GeneralMixin from "@/components/mixins/General";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [GeneralMixin],
  data: function () {
    return {
      idsolicitudmodificarhorario: null,
      motivos_de_rechazo: [],
      solicitud: {},
      available_days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
      dias: [],
    };
  },
  activated() {
    this.Init();
  },
  computed: {
    ...mapGetters("horarios", ["menu"]),
  },
  methods: {
    ...mapActions("horarios", ["setComponent"]),
    Volver() {
      this.setComponent({ component: "home" });
    },
    Rechazar() {
      if (this.solicitud.idmotivorechazo == null) {
        swal("Motivo de rechazo", "Favor de seleccionar un motivo de rechazo", "error");
      } else {
        const url = this.Obtener_Url("modificarHorario/solicitud/evaluar/" + this.idsolicitudmodificarhorario);
        this.$http
          .put(
            url,
            {
              aprobar: false,
              idmotivorechazo: this.solicitud.idmotivorechazo,
            },
            {
              headers: this.get_request_headers({
                accesstoken: localStorage.getItem("tokenmsal"),
              }),
            }
          )
          .then((response) => {
            swal("Solicitud Rechazada", "La solicitud fue rechazada", "success");
            this.solicitud.status = 4;
            this.solicitud.nomestatus = "No Autorizado";
            this.Volver();
          })
          .catch((error) => {
            if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
              this.$msal.signOut();
            }
            if (_.has(error, "body.resp")) {
              swal("Error", error.body.resp, "error");
            } else {
              swal("Error", "Ha ocurrido un error inesperado", "error");
            }
          });
      }
    },
    Aprobar() {
      const url = this.Obtener_Url("modificarHorario/solicitud/evaluar/" + this.idsolicitudmodificarhorario);
      this.$http
        .put(
          url,
          {
            aprobar: true,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((response) => {
          swal("Solicitud Autorizada", "La solicitud fue autorizada con exito", "success");
          this.solicitud.status = 5;
          this.solicitud.nomestatus = "Autorizado";
          this.solicitud.idmotivorechazo = null;
          this.Volver();
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          if (_.has(error, "body.resp")) {
            swal("Error", error.body.resp, "error");
          } else {
            swal("Error", "Ha ocurrido un error inesperado", "error");
          }
        });
    },
    Init() {
      this.idsolicitudmodificarhorario = this.menu.item;

      const url_motivos = this.Obtener_Url("motivos/rechazo");
      const url_solicitud = this.Obtener_Url("modificarHorario/solicitud/" + this.idsolicitudmodificarhorario);
      const motivos_rechazo = this.$http.get(url_motivos, {
        headers: this.get_request_headers({
          accesstoken: localStorage.getItem("tokenmsal"),
        }),
      });
      const solicitud = this.$http.get(url_solicitud, {
        headers: this.get_request_headers({
          accesstoken: localStorage.getItem("tokenmsal"),
        }),
      });

      Promise.all([motivos_rechazo, solicitud])
        .then((responses) => Promise.all(responses.map((r) => r.json())))
        .then(([motivos, result]) => {
          const fc = moment.utc(result.fecha_creacion);
          fc.tz("America/Monterrey");
          const days = result.dias.map((day, index) => ({
            ...day,
            title: this.available_days[parseInt(day.dia) - 1],
            tiempo_lunch: day.tiempo_lunch / 60,
          }));

          const s = {
            ...result,
            fecha_creacion: fc.format("DD/MM/YYYY HH:mm"),
          };

          this.solicitud = s;
          this.dias = days;
          this.motivos_de_rechazo = motivos;
        });
    },
  },
};
</script>

<style>
.label-lunch {
  padding-left: 30px !important;
}
</style>
